import React, { useState } from "react";
import styled from "styled-components";
import Link from "next/link";

const Container = styled.div`
    visibility: ${(props) => (props.isVisible ? "visible" : "hidden")};
`;

const Backdrop = styled.div`
    background-color: ${(props) => (props.isVisible ? "rgba(0,0,0,0.5)" : "rgba(0,0,0,0)")};
    position: fixed;
    z-index: 2;
    top: 0;
    height: 100%;
    width: 100%;
    transition: all 0.2s ease-in;
`;

const Menu = styled.div`
    nav {
        position: fixed;
        white-space: nowrap;
        top: 0;
        right: 0;
        z-index: 3;
        width: ${(props) => (props.isVisible ? "240px" : "0px")};
        box-sizing: content-box;
        background-color: #5064ee;
        padding: 130px 30px 30px 30px;
        color: white !important;
        height: 100%;
        transition: all 0.3s ease-in;

        li {
            font-size: 18px;
            margin-bottom: 20px;
        }

        li a {
            color: white !important;
            text-decoration: none;
        }
    }
`;

const SideNavBar = (props) => {
    const [isVisible, setIsVisible] = useState(props.isVisible);

    return (
        <Container isVisible={props.isVisible}>
            <Backdrop isVisible={props.isVisible} onClick={() => props.setShowMenu(false)} />
            <Menu isVisible={props.isVisible}>
                <nav>
                    <ul>
                        {props.items.map((item, index) => (
                            <li key={index}>
                                {item.isLinkOut === true ? (
                                    <a href={item.url}>{item.item}</a>
                                ) : (
                                    <Link href={item.url}>
                                        <a>{item.item}</a>
                                    </Link>
                                )}
                            </li>
                        ))}
                    </ul>
                </nav>
            </Menu>
        </Container>
    );
};

export default SideNavBar;
